import {
  TemplateFieldV2,
  Document,
} from "../../../../docuclipper/DocuclipperTypes";

function range(start, end) {
  const ans: number[] = [];
  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const parseNumberOrInterval = (interval: string) => {
  const num = /^(\d+$)/.exec(interval);
  if (num && num.length > 1) {
    const num2 = parseInt(num[1], 10);
    if (num2 < 1) {
      throw new Error(`Invalid page number ${num2}`);
    }
    return range(num2 - 1, num2 - 1);
  }
  const ival = /(\d+)-(\d+)/.exec(interval);
  if (ival && ival.length > 2) {
    const num1 = parseInt(ival[1], 10);
    const num2 = parseInt(ival[2], 10);
    if (num1 < 1 || num2 < 1) {
      throw new Error(`Invalid page range ${num1}-${num2}`);
    }

    return range(num1 - 1, num2 - 1);
  }
  throw new Error("Error parsing number of interval");
};

const getPageRange = (
  numPages: number,
  include: string[],
  exclude: string[]
) => {
  include = include || [];
  exclude = exclude || [];
  if (include.length > 0 && exclude.length > 0) {
    throw new Error(`Can't specify include and exclude at the same time`);
  }
  if (include.length === 0 && exclude.length === 0) {
    return range(0, numPages - 1);
  }

  if (include.length > 0) {
    let pages: number[] = [];
    for (const item of include) {
      pages = pages.concat(parseNumberOrInterval(item));
    }
    return pages;
  }

  if (exclude.length > 0) {
    const excludedPages: { [key: string]: boolean } = {};
    for (const e of exclude) {
      const r = parseNumberOrInterval(e);
      for (const page of r) {
        excludedPages[page] = true;
      }
    }

    const pages: number[] = [];
    for (let i = 0; i < numPages; i += 1) {
      if (!(i in excludedPages)) {
        pages.push(i);
      }
    }
    return pages;
  }
  throw new Error("Unable to get page range");
};

export const isFieldInPage = ({
  field,
  currentPage,
  document,
}: {
  field: TemplateFieldV2;
  currentPage: number;
  document: Document;
}) => {
  let fieldIsPresentInThisPage = false;
  if (
    field.pages.pagesType === "allPages" ||
    field.locationType === "variable"
  ) {
    return true;
  }
  if (field.pages.pagesType === "custom") {
    const pageRange = getPageRange(
      document.numPages,
      field.pages.include || [],
      field.pages.exclude || []
    );
    fieldIsPresentInThisPage =
      pageRange.find((x) => x === currentPage) !== undefined;
  } else {
    fieldIsPresentInThisPage = field.pages.page === currentPage;
  }
  return fieldIsPresentInThisPage;
};
